import { HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, FactoryProvider, LOCALE_ID, StaticProvider, ValueProvider } from '@angular/core';

import { AppConfig } from '../app-config.types';
import {
  APP_CONFIG,
  BACK_API_URL,
  BYTES_ATTACHMENT_MAX_SIZE,
  BYTES_LIST_ATTACHMENT_MAX_SIZE,
  DEFAULT_INIT_PAYLOAD_TOKEN,
  READ_UNREAD_BEGIN_DATE,
  ENABLE_VOCAL_MESSAGE,
} from './app.tokens';
import { HttpNoopInterceptor } from './lib/http/noop.interceptor';
import { HttpUrlRewriteInterceptor } from './lib/http/url-rewrite.interceptor';
import { ErrorInterceptor } from './shared/services/errors-interceptor.service';
import { TokenInterceptor } from './shared/services/token-interceptor.service';
import { createTagCommanderConfig, TAG_COMMANDER_CONFIG } from './shared/tag-commander/tag-commander.providers';

export const APP_CURRENCY_CODE_PROVIDER: ValueProvider = { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' };

export const APP_LOCALE_PROVIDER: ValueProvider = { provide: LOCALE_ID, useValue: 'fr-Fr' };

export const BACK_API_INTERCEPTOR_PROVIDER: FactoryProvider = {
  provide: HTTP_INTERCEPTORS,
  useFactory: (backApiUrl: string): HttpInterceptor =>
    backApiUrl === '/api'
      ? new HttpNoopInterceptor()
      : new HttpUrlRewriteInterceptor({ fromUrl: '/api', targetUrl: backApiUrl }),
  deps: [BACK_API_URL],
  multi: true,
};

export const TOKEN_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenInterceptor,
  multi: true,
};

export const ERROR_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorInterceptor,
  multi: true,
};
export function provideBackApiUrl(backApiUrl: string): ValueProvider {
  return {
    provide: BACK_API_URL,
    useValue: backApiUrl,
  };
}

export function createAppConfigProviders(appConfig: AppConfig): StaticProvider[] {
  return [
    {
      provide: APP_CONFIG,
      useValue: appConfig,
    },
    {
      provide: TAG_COMMANDER_CONFIG,
      useValue: createTagCommanderConfig(appConfig.TAG_COMMANDER_ENV),
    },
    {
      provide: BYTES_ATTACHMENT_MAX_SIZE,
      useValue: appConfig.BYTES_ATTACHMENT_MAX_SIZE,
    },
    {
      provide: BYTES_LIST_ATTACHMENT_MAX_SIZE,
      useValue: appConfig.BYTES_LIST_ATTACHMENT_MAX_SIZE,
    },
    {
      provide: DEFAULT_INIT_PAYLOAD_TOKEN,
      useValue: appConfig.DEFAULT_INIT_PAYLOAD_TOKEN,
    },
    {
      provide: READ_UNREAD_BEGIN_DATE,
      useValue: appConfig.READ_UNREAD_BEGIN_DATE,
    },
    {
      provide: ENABLE_VOCAL_MESSAGE,
      useValue: appConfig.ENABLE_VOCAL_MESSAGE,
    },
  ];
}
